import { create } from 'zustand';

type GoLivePreviewHoldState = {
  /** Flow binding that started go-live. Current and Next stay covered until that pair is painted. */
  owner: string | null;
  generation: number;
  /** Mounted Now/Next stacks that can release the hold when the pair is painted. */
  consumers: number;
  hold: (owner: string) => number;
  /** Clears the hold when it still belongs to this owner. A generation skips a newer hold. */
  release: (owner: string, generation?: number) => void;
  mountPreviewConsumer: () => void;
  unmountPreviewConsumer: () => void;
};

export const useGoLivePreviewHold = create<GoLivePreviewHoldState>((set, get) => ({
  owner: null,
  generation: 0,
  consumers: 0,
  hold: (owner) => {
    const generation = get().generation + 1;
    set({ owner, generation });
    return generation;
  },
  release: (owner, generation) => {
    const state = get();
    if (state.owner !== owner) {
      return;
    }
    if (generation != null && state.generation !== generation) {
      return;
    }
    set({ owner: null });
  },
  mountPreviewConsumer: () => {
    set({ consumers: get().consumers + 1 });
  },
  unmountPreviewConsumer: () => {
    const consumers = Math.max(0, get().consumers - 1);
    // The list layout never mounts a preview. Drop a hold that nothing can finish.
    set(consumers === 0 ? { consumers, owner: null } : { consumers });
  },
}));
